export const PUBLISH_SLIDESHOW_START = 'PUBLISH_SLIDESHOW_START';
export const PUBLISH_SLIDESHOW_SUCCESS = 'PUBLISH_SLIDESHOW_SUCCESS';
export const PUBLISH_SLIDESHOW_FAILURE = 'PUBLISH_SLIDESHOW_FAILURE';

export const CONVERT_FILE_START = 'CONVERT_FILE_START';
export const CONVERT_FILE_SUCCESS = 'CONVERT_FILE_SUCCESS';
export const CONVERT_FILE_DEBUG_SUCCESS = 'CONVERT_FILE_DEBUG_SUCCESS';
export const CONVERT_FILE_FAILURE = 'CONVERT_FILE_FAILURE';
export const CONVERT_FILE_RESET = 'CONVERT_FILE_RESET';

// Editor actions
export const FETCH_DOCUMENTS_START = 'FETCH_DOCUMENTS_START';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE';

export const FETCH_DOCUMENT_START = 'FETCH_DOCUMENT_START';
export const FETCH_DOCUMENT_SUCCESS = 'FETCH_DOCUMENT_SUCCESS';
export const FETCH_DOCUMENT_FAILURE = 'FETCH_DOCUMENT_FAILURE';

export const CREATE_DOCUMENT_START = 'CREATE_DOCUMENT_START';
export const CREATE_DOCUMENT_SUCCESS = 'CREATE_DOCUMENT_SUCCESS';
export const CREATE_DOCUMENT_FAILURE = 'CREATE_DOCUMENT_FAILURE';

export const UPDATE_DOCUMENT_START = 'UPDATE_DOCUMENT_START';
export const UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS';
export const UPDATE_DOCUMENT_FAILURE = 'UPDATE_DOCUMENT_FAILURE';

export const DELETE_DOCUMENT_START = 'DELETE_DOCUMENT_START';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';
export const DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE';

export const IMPORT_DOCUMENT_START = 'IMPORT_DOCUMENT_START';
export const IMPORT_DOCUMENT_SUCCESS = 'IMPORT_DOCUMENT_SUCCESS';
export const IMPORT_DOCUMENT_FAILURE = 'IMPORT_DOCUMENT_FAILURE';

export const SELECT_SLIDE = 'SELECT_SLIDE';
export const SELECT_ELEMENT = 'SELECT_ELEMENT';
export const UPDATE_PRESENTATION_LOCAL = 'UPDATE_PRESENTATION_LOCAL';
export const REMOTE_DOCUMENT_UPDATED = 'REMOTE_DOCUMENT_UPDATED';

// AI Draft review
export const AI_DRAFT_SUCCESS = 'AI_DRAFT_SUCCESS';
export const UPDATE_DRAFT_SLIDES = 'UPDATE_DRAFT_SLIDES';
export const CLEAR_DRAFT = 'CLEAR_DRAFT';
export const GENERATE_FROM_DRAFT_START = 'GENERATE_FROM_DRAFT_START';
export const GENERATE_FROM_DRAFT_FAILURE = 'GENERATE_FROM_DRAFT_FAILURE';
